




























































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseModel from "@/models/base/BaseModel.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import { AxiosResponse } from "axios";
import UserService from "@/services/user.service";
import ResearchCenterService from "@/services/researchCenter.service";
import User from "@/models/security/user.model";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
@Component({
  components: {
    ResearchCenterBasicInformationComponent
  }
})
export default class BaseSelectResearchCenterReport extends Vue {
  @Prop() public label!: string;
  @Prop() public controller!: string;
  @Prop() public action!: string;
  @Prop() public placeholder!: string;
  @Prop() public disabled!: boolean;
  @Prop({ default: false }) public multiple!: boolean;
  @Prop() public value: any;
  @Prop() public initOnDisable!: boolean;
  @Prop() public hideSelected!: boolean;
  @Prop() public isSearchable!: boolean;
  @Prop({ default: false }) public useLocalOptions!: boolean;
  @Prop() public getsResearchCentersByUser!: boolean;
  @Prop() public getcenterByInvestigator!: boolean;
@Prop() public searchCenterById!:boolean;
  @Prop() public options: [];


  userService: UserService = new UserService();
  researchCenterService: ResearchCenterService = new ResearchCenterService();
  selected: any = null;
  data: any = [];
  loading: boolean = false;
  nombre: any = null;
  timerFunction: any;

  get sAction() {
    return this.action ? "/" + this.action : "";
  }

  get user() {
    return this.$store.state.user;
  }

  formatNombreInstitucion(nombre: string) {
    if (nombre.length > 70) {
      return nombre.substring(0, 60) + "...";
    }
    return nombre;
  }

  customLabel({ id, name, image, abbreviation, provinceName }: any) {
    let label = this.getProfileImage(image) + `- ${name}`;
    return label;
  }

  getProfileImage(profileImage: any) {
    if (profileImage && profileImage)
      return `data:image/jpg;base64, ${profileImage}`;
    return false;
  }

  getResearchCentersByUser() {
      this.userService.researchCenterByUser(this.user.id).then( center => {
        this.data = center;
      }).finally(() => {
        this.loading = false;
      });
  }

  getAllResearchCenters() {
    if (this.researchCenterService) {
      this.loading = true;
      this.researchCenterService
        .getResearchCenterWithProvinces()
        .then(center => {
          this.data = center;
          this.loading = false;
        });
    }
  }
   onSelected(selected: BaseModel) {
    this.$emit("input", selected.id);
    this.$emit("select", selected);
    this.$emit("onChange", selected);
  }

  mounted() {
    if (!this.useLocalOptions) {
      if (!this.isSearchable) {
        if (this.getsResearchCentersByUser) { 
          this.getResearchCentersByUser();
        } else if (this.getcenterByInvestigator) {
          this.getCenterByInvestigatorId(); 
        } else {
          this.getAllResearchCenters();
        } 
      }
    }
  }
  

  getCenterByInvestigatorId() {
    this.userService
      .researchCenterByInvestigator(this.user.id)
      .then(center => {
        this.data = center;
        if(this.value){
          this.selected = this.data.find(x => x.id == this.value);
        }
    });
  }

  searchChange(text: string) {
    this.nombre = text;
    this.$emit("searchChange", text);
  }
  getResearchCenter(value?: any) {
    if (!this.useLocalOptions) {
      this.loading = true;
      if (this.isSearchable) {
        if (this.timerFunction) {
          clearTimeout(this.timerFunction);
        }
        if (this.nombre) {
          this.timerFunction = setTimeout(() => {
            this.researchCenterService
              .getResearchCenterByCriteria(this.nombre)
              .then(researchCenters => {
                if (researchCenters) {
                  if (this.data && this.data.length > 0) {
                    researchCenters.forEach((person: any) => {
                      if (!this.data.some((x: any) => x.id == person.id)) {
                        this.data.unshift(person);
                      }
                    });
                  } else {
                    this.data = researchCenters;
                    if (value) {
                      this.selected = this.data.find(x => x.id == value);
                    }
                    this.loading = false;
                  }
                  this.loading = false;
                }
              });
          }, 500);
        }
      } else {
        if (this.getsResearchCentersByUser) this.getResearchCentersByUser();
        else this.getAllResearchCenters();
      }
    }
  }

  @Watch("selected")
  onSelectChange() {
    
    if (this.selected) {
      this.$emit("input", this.selected.id);
      this.$emit("selected", this.selected);
    } else {
      this.$emit("input", null);
      this.$emit("selected", null);
    }
  }

  @Watch("value")
  onValueChange(value: any) {
    if (this.searchCenterById && !isNaN(value)) {
     this.researchCenterService.getCenterById(value).then(response =>{
           this.selected = response;
      })
    }
  }



  @Watch("nombre")
  onNombreChange(value?: string) {
    if (value && this.isSearchable) {
      this.getResearchCenter(value);
    }
  }

  @Watch("options")
  onOptionsChange(value?: string) {
    if (value && this.options.length > 0) {
      this.data = this.options;
    }
  }
}
